export function activePlanCustomizations(plan) {
    return (Array.isArray(plan?.customizations) ? plan.customizations : [])
        .filter((customization) => customization?.isActive !== false);
}

export function defaultCustomizationSelections(plan) {
    return Object.fromEntries(activePlanCustomizations(plan).map((customization) => {
        const defaults = (customization.options || [])
            .filter((option) => option?.isActive !== false && option?.isDefault === true)
            .map((option) => String(option.documentId));
        return [String(customization.documentId), customization.selectionMode === "multiple" ? defaults : (defaults[0] || "")];
    }));
}

export function customizationPayload(plan, selections) {
    return activePlanCustomizations(plan).flatMap((customization) => {
        const selected = selections?.[String(customization.documentId)];
        const optionDocumentIds = (Array.isArray(selected) ? selected : [selected]).filter(Boolean).map(String);
        return optionDocumentIds.length ? [{
            customizationDocumentId: customization.documentId,
            optionDocumentIds,
        }] : [];
    });
}

export function customizationSelectionsComplete(plan, selections) {
    return activePlanCustomizations(plan).every((customization) => {
        const selected = selections?.[String(customization.documentId)];
        const count = (Array.isArray(selected) ? selected : [selected]).filter(Boolean).length;
        const minimum = Number(customization.minimumSelections ?? (customization.isRequired === false ? 0 : 1));
        const maximum = Number(customization.maximumSelections ?? 1);
        return count >= minimum && count <= maximum;
    });
}
